<template>
  <div class="value mb-4">

    <!-- Баланс -->
    <div class="value__item mr-3" v-if="blocks.indexOf('balance') >= 0">
      <div class="value__vol">{{ toCurrency(balance > 0 ? balance : 0, currency) }}</div>
      <div class="value__label">
        баланс
      </div>
      <svg style="color: #056dbd" xmlns="http://www.w3.org/2000/svg" class="size-5 text-primary dark:text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>

    <!-- Задолженность -->
    <div class="value__item" v-if="blocks.indexOf('debt') >= 0">
      <div class="value__vol">{{ toCurrency(debt > 0 ? debt : 0, currency) }}</div>
      <div class="value__label">
        к оплате
      </div>
      <svg style="color: #10b981" xmlns="http://www.w3.org/2000/svg" class="size-5 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
      </svg>
    </div>

    <!-- Без акта -->
    <div class="value__item" v-if="blocks.indexOf('act') >= 0">
      <div class="value__vol">{{ toCurrency(withOutActs, currency) }}</div>
      <div class="value__label">без акта</div>
      <svg style="color: #10b981" xmlns="http://www.w3.org/2000/svg" class="size-5 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
      </svg>
    </div>

    <!-- Планирование -->
    <div class="value__item" v-if="blocks.indexOf('planning') >= 0">
      <div class="value__vol">{{ toCurrency(selectedSum, currency) }}</div>
      <div class="value__label">сумма</div>
      <svg style="color: #056dbd" xmlns="http://www.w3.org/2000/svg" class="size-5 text-primary dark:text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>

    <!-- Сумма в архиве -->
    <div class="value__item" v-if="blocks.indexOf('archive') >= 0">
      <div class="value__vol">{{ toCurrency(archiveSumPrice, currency) }}</div>
      <div class="value__label">сумма</div>
      <svg style="color: #056dbd" xmlns="http://www.w3.org/2000/svg" class="size-5 text-primary dark:text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>

  </div>
</template>

<script>
import Helper from '@/classes/helper'
import { useFinStore } from '@/stores/fin'
import { mapState } from 'pinia/dist/pinia'
export default {
  name: 'ValuesBlocks',
  props: ['blocks', 'archiveSumPrice'],
  computed: {
    ...mapState(useFinStore, ['balance', 'debt', 'withOutActs', 'selectedSum', 'currency']),
  },
  methods: {
    toCurrency: Helper.toCurrency,
  }
}
</script>
